export var CountryAdminUrl :Array<String> =[
      "",
      "user",
      "changePassword",
      "user/add",
      "institution/add",
      "dashboard",
      "elearning",
      "elearning/manage",
      "elearning/puzzles",
      "elearning/puzzles/start/:id",
      "sop",
      "sop/create",
      "sop/duplicate/:sopId",
      "sop/duplicate/:sopId/:versionNo",
      "sop/:viewType/:sopId",
      "sop/:viewType/:sopId/:versionNo",
      "institution",
      "institution/add",
      "institution/trial",
      "institution/view/:id",
      "institution/edit/:id",
      "user/add",
      "user/addInstitution/:institutionId/:isGroup",
      "user/edit/:userid",
      "user",
      "user/view/:userid",
      "configure",
      "activate",
      "department",
      "image-library",
      "professional-category",
      "sub-category",
      "general",
      "comments",
      "tutorial",
      "tutorial/edit/:tutorialID",
      "tutorial/add",
      "evaluation",
      "evaluation/observeSOP/processCompliance",
      "evaluation/observeSOP/frequencyDistribution",
      "evaluation/observeSOP/subStepCompliance",
      "evaluation/observeSOP/sopComments",
      "evaluation/observeSOP/sopIndividualOverview",
      "observeObservation/statistical",
      "evaluation/observe/overallCompliance",
      "evaluation/observe/fivemoments",
      "evaluation/observe/quota",
      "evaluation/observe/StatisticsBeforeAsepticProcedures",
      "evaluation/observe/individualOverview",
      "evaluation/observe/comments",
      "evaluation/hygiene-check/statistical",
      "evaluation/hygiene-check/quickComments",
      "evaluation/hygiene-check/complianceQuestions",
      "evaluation/hygiene-check/overallCompliance",
      "evaluation/hygiene-check/individualData",
      "reportSop",
      "evaluation/observeSOP/reportSop",
      "evaluation/observeSOP/statistical",
      "statistical",
      "evaluation/consumption",
      "consumption",
      "consumption/new",
      "consumption/past/start/:period/:Id",
      "consumption/new/start/:Id",
      "consumption/past",
      'list',
      'detail',
      'profile',
      'reports',
      'overview',
      'users',
      'institutionUsers',
      'exportWebKess',
      'webKessSettings',
      'webKessReports',
      "check-comments",
      "check-predefined-comments",
      'country-settings',
      "consumption/statistical",
      "evaluation/consumption/totalConsumption",
      "evaluation/consumption/consumptionPerPatient",
      'questionnaire-editor/:id',
      'questionnaire-viewer/:id',
      "hygiene-check-editor",
      "view/:id"
    ];
